import React from "react";
import {Modal} from "@mui/material";
import {isEqual} from "lodash";
import {useViewController} from "data/services/locator/locator_hook.service";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {ModalType} from "data/enums";
import {observer} from "mobx-react";
import {Bindings} from "data/constants/bindings";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconInfo} from "assets/img/icon/icon-info-gold.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {SecondaryButton} from "views/components/style";

export const UncompleteModal: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, close} = controller;
	const isVisible = isEqual(visibleModal, ModalType.EMPTY_LINEUP);

	if (!isVisible) {
		return null;
	}

	const title = i18n.t("modal.uncomplete.title", "Oops, you’re missing picks");
	const message = i18n.t(
		"modal.uncomplete.description",
		"You have not completed this step, you cannot continue until you have selected all players"
	);

	return (
		<Modal open={isVisible} onClose={close}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconInfo />
					</ModalHeader>
					<ModalBody>
						<ModalTitle>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={close}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						{/*<PrimaryButton*/}
						{/*	fullWidth*/}
						{/*	onClick={close}*/}
						{/*	variant="contained"*/}
						{/*	size="large">*/}
						{/*	{i18n.t("modal.saved.share_btn", "Share")}*/}
						{/*</PrimaryButton>*/}
						<SecondaryButton
							onClick={close}
							fullWidth
							variant="contained"
							size="large"
							style={{maxWidth: "320px"}}>
							{i18n.t("modal.uncomplete.done_btn", "Stay and complete")}
						</SecondaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
